import { Card } from "antd";
import { ContainerCard, CardStyle, images } from "../styles";

export default function HotelNacional() {
  const { Meta } = Card;

  return (
    <ContainerCard>
      <Card
        hoverable
        style={CardStyle}
        cover={
          <a href="/empreendimentos/autorizacao/autorizacao-hotel-nacional.pdf">
            <img
              alt="autorizacao"
              src={images.autorizacao}
              style={{ width: "100%", height: "auto" }} // Ajuste o tamanho da imagem
            />
          </a>
        }
      >
        <Meta
          title="Autorização de Hospedagem"
          description="Última atualização em: 12/09/2024"
        />
      </Card>
    </ContainerCard>
  );
}
